export const fmtNum = (v, d = 0) => {
  if (v === null || v === undefined || Number.isNaN(v)) return "–";
  const n = Number(v);
  if (Number.isNaN(n)) return "–";
  return n.toLocaleString("en-US", { minimumFractionDigits: d, maximumFractionDigits: d });
};

export const fmtMoney = (v) => {
  if (v === null || v === undefined || Number.isNaN(Number(v))) return "–";
  return "$" + Number(v).toLocaleString("en-US", { maximumFractionDigits: 0 });
};

export const fmtMoneyShort = (v) => {
  if (v === null || v === undefined || Number.isNaN(Number(v))) return "–";
  const n = Number(v);
  const a = Math.abs(n);
  const sign = n < 0 ? "-" : "";
  if (a >= 1e9) return `${sign}$${(a / 1e9).toFixed(2)}B`;
  if (a >= 1e6) return `${sign}$${(a / 1e6).toFixed(2)}M`;
  if (a >= 1e3) return `${sign}$${(a / 1e3).toFixed(1)}K`;
  return `${sign}$${a.toFixed(0)}`;
};

export const fmtCover = (v) => {
  if (v === null || v === undefined || Number.isNaN(Number(v))) return "∞";
  return Number(v).toFixed(1);
};

export const fmtQty = (v) => {
  if (v === null || v === undefined || Number.isNaN(Number(v))) return "–";
  const n = Number(v);
  return Number.isInteger(n) ? fmtNum(n) : fmtNum(n, 2);
};

export const fmtLt = (v) => (v === null || v === undefined || Number.isNaN(Number(v)) ? "–" : `${Number(v).toFixed(2)}`);
